import { Card } from '../../components/Card/Card';
import { ACCENT_PRESETS, setAccent } from '../../lib/palette';
import { useMe, useUpdateHousehold } from '../../store/queryHooks';
import { useUiStore } from '../../store/ui';
import styles from './AccentPicker.module.css';

export function AccentPicker() {
  const me = useMe();
  const update = useUpdateHousehold();
  const setToast = useUiStore((s) => s.setToast);
  const current = me.data?.accent_color ?? '#4b3fb5';

  async function pick(hex: string) {
    setAccent(hex); // immediate visual feedback
    try {
      await update.mutateAsync({ accent_color: hex });
      setToast('Accent-farve gemt');
    } catch {
      setAccent(current); // revert
      setToast('Kunne ikke gemme accent-farve');
    }
  }

  return (
    <Card className={styles.card}>
      <h2 className={styles.title}>Accent-farve</h2>
      <p className={styles.sub}>Skifter fremhævningsfarven overalt i appen.</p>
      <div className={styles.row}>
        {ACCENT_PRESETS.map((hex) => (
          <button
            key={hex}
            className={`${styles.swatch} ${current.toLowerCase() === hex.toLowerCase() ? styles.selected : ''}`}
            style={{ background: hex }}
            onClick={() => pick(hex)}
            title={hex}
          />
        ))}
      </div>
    </Card>
  );
}
